import { app } from './Api';

/**
 * Lista arquivos do diretório com filtros
 * @param {Array} equipamentoIds - Array de IDs dos equipamentos
 * @param {string} dataInicio - Data de início (YYYY-MM-DD)
 * @param {string} dataFim - Data de fim (YYYY-MM-DD)
 * @param {string|number} idUnit - ID da unidade (se 14725896312 ou vazio, traz todos)
 * @returns {Promise}
 */
const listDiretorio = async (equipamentoIds = [], dataInicio = null, dataFim = null, idUnit = null) => {
  const params = {};
  
  if (equipamentoIds && equipamentoIds.length > 0) {
    params.equipamento_ids = equipamentoIds;
  }
  
  if (dataInicio) {
    params.data_inicio = dataInicio;
  }
  
  if (dataFim) {
    params.data_fim = dataFim;
  }

  // Adiciona filtro de unidade apenas se não for 14725896312 ou vazio
  if (idUnit && idUnit !== '14725896312' && idUnit !== '') {
    params.id_unit = idUnit;
  }

  return app.get('diretorio', { params });
};

/**
 * Lista todos os equipamentos para popular o select
 * @returns {Promise}
 */
const getEquipamentos = async () => {
  return app.get('diretorio/equipamentos');
};

/**
 * Download de arquivo individual
 * @param {number} arquivoId - ID do arquivo
 * @returns {Promise}
 */
const downloadArquivo = async (arquivoId) => {
  const response = await app.get(`diretorio/download/${arquivoId}`, {
    responseType: 'blob',
  });
  
  // Tentar obter o nome do arquivo do header Content-Disposition
  const contentDisposition = response.headers['content-disposition'];
  let fileName = `arquivo_${arquivoId}`;
  
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch) {
      fileName = decodeURIComponent(fileNameMatch[1]);
    }
  }
  
  // Criar link temporário para download usando o blob diretamente
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return response;
};

/**
 * Download de múltiplos arquivos em ZIP
 * @param {Array} arquivoIds - Array de IDs dos arquivos
 * @returns {Promise}
 */
const downloadZip = async (arquivoIds) => {
  const response = await app.post('diretorio/download-zip', {
    arquivo_ids: arquivoIds
  }, {
    responseType: 'blob',
  });
  
  // Criar link temporário para download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `arquivos_${new Date().toISOString().split('T')[0]}.zip`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return response;
};

export { listDiretorio, getEquipamentos, downloadArquivo, downloadZip };

